export default "__VITE_ASSET__BQ44MCHw__"